import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';
import { normalizeListResponse } from './normalizers';

const CATEGORY_URL = COMMUNITY_ENDPOINTS.CATEGORIES;
const TAG_URL = COMMUNITY_ENDPOINTS.TAGS;

export const categories = {
  getAll: (params = {}) => communityHttpClient.get(`${CATEGORY_URL}/`, { params }),
  getBySlug: (slug) => communityHttpClient.get(`${CATEGORY_URL}/${slug}/`),
  create: (data) => communityHttpClient.post(`${CATEGORY_URL}/`, data),
  update: (slug, data) => communityHttpClient.put(`${CATEGORY_URL}/${slug}/`, data),
  delete: (slug) => communityHttpClient.delete(`${CATEGORY_URL}/${slug}/`),
  getWithCounts: (params = {}) => communityHttpClient.get(`${CATEGORY_URL}/with_counts/`, { params }),
  normalize: async (params = {}) => {
    const response = await communityHttpClient.get(`${CATEGORY_URL}/`, { params });
    return normalizeListResponse(response.data).results;
  }
};

export const tags = {
  getAll: (params = {}) => communityHttpClient.get(`${TAG_URL}/`, { params }),
  getBySlug: (slug) => communityHttpClient.get(`${TAG_URL}/${slug}/`),
  create: (data) => communityHttpClient.post(`${TAG_URL}/`, data),
  update: (slug, data) => communityHttpClient.put(`${TAG_URL}/${slug}/`, data),
  delete: (slug) => communityHttpClient.delete(`${TAG_URL}/${slug}/`),
  approve: (slug, data = {}) => communityHttpClient.post(`${TAG_URL}/${slug}/approve/`, data),
  reject: (slug, data = {}) => communityHttpClient.post(`${TAG_URL}/${slug}/reject/`, data),
  restore: (slug, data = {}) => communityHttpClient.post(`${TAG_URL}/${slug}/restore/`, data),
  getPopular: (params = {}) => communityHttpClient.get(`${TAG_URL}/popular/`, { params }),
  normalize: async (params = {}) => {
    const response = await communityHttpClient.get(`${TAG_URL}/`, { params });
    return normalizeListResponse(response.data).results;
  }
};

export default {
  categories,
  tags
};
